import chef from './chef.png'

export { chef }



// WEBPACK FOOTER //
// ./src/components/Chef/images/index.js